export const EMPTY_PLUS_TAG_MESSAGE =
    "Email address cannot contain a '+' directly before '@'";

/**
 * Returns true when the local part of the address ends with a "+" (for
 * example "name+@domain.com"). Such addresses pass validator.isEmail and
 * Cognito, but are not deliverable mailboxes and hard-bounce, which gets the
 * address added to the SES suppression list. Tagged addresses like
 * "name+tag@domain.com" are still allowed.
 *
 * Keep in sync with the marketbox repo lambdas:
 * amplify/backend/function/userManagementService/src/emailValidation.js
 */
export function hasEmptyPlusTag(email) {
    if (typeof email !== "string") return false;
    return /^[^@]*\+@/.test(email.trim());
}
